import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PRODUCTS_STATUS_QUERY_KEY } from '@/apiHooks/queryKeys';
import { registerStoragebox } from '../api/storagebox/getStoragebox';
import type { StorageboxData } from '../@types/storagebox';

export const useRegisterStoragebox = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isSuccess, isLoading } = useMutation(
    async (formData: StorageboxData) => {
      const data = await registerStoragebox(formData);
      return data;
    },
    {
      onSuccess: () => queryClient.invalidateQueries(PRODUCTS_STATUS_QUERY_KEY),
      onError: () => queryClient.invalidateQueries(PRODUCTS_STATUS_QUERY_KEY),
    },
  );
  return { mutate: mutateAsync, isSuccess, isLoading };
};
